import React from "react";

const Skills = () => {
  const skillsContent = [
    {
      id: 1,
      colClass: "left",
      title: "Tools & Technologies",
      progress: [
        {
          id: 1,
          skillName: "Emerging Technologies",
          skillValue: "90",
        },
        {
          id: 2,
          skillName: "Hardware Design and Manufacturing",
          skillValue: "80",
        },
        {
          id: 3,
          skillName: "Protocols and Connectivity",
          skillValue: "80",
        },
        {
          id: 4,
          skillName: "Edge & Cloud Computing",
          skillValue: "80",
        },
        {
          id: 5,
          skillName: "Digital Twins",
          skillValue: "80",
        },
        {
          id: 6,
          skillName: "Smart Cities",
          skillValue: "70",
        },
        {
          id: 7,
          skillName: "Cybersecurity",
          skillValue: "70",
        },
        {
          id: 8,
          skillName: "5G",
          skillValue: "60",
        },
      ],
    },
    {
      id: 2,
      colClass: "right",
      title: "Interpersonal Skills",
      progress: [
        {
          id: 1,
          skillName: "Leadership and Teamwork",
          skillValue: "90",
        },
        {
          id: 2,
          skillName: "Strategist",
          skillValue: "90",
        },
        {
          id: 3,
          skillName: "Motivation and Customer Driven",
          skillValue: "90",
        },
        {
          id: 4,
          skillName: "Positive and Cheerful",
          skillValue: "90",
        },
        {
          id: 5,
          skillName: "Solution Oriented Problem Solver",
          skillValue: "90",
        },
        {
          id: 6,
          skillName: "Active Listening",
          skillValue: "90",
        },
        {
          id: 7,
          skillName: "Empathy adn Communication",
          skillValue: "90",
        },
        {
          id: 8,
          skillName: "Philomath",
          skillValue: "90",
        },
      ],
    },
  ];
  return (
    <>
      {skillsContent.map((item) => (
        <div className={item.colClass} key={item.id}>
          <div className="tokyo_section_title">
            <h3>{item.title}</h3>
          </div>

          <div className="tokyo_progress">
            {item?.progress?.map((skill) => (
              <div
                className="progress_inner"
                data-value={item.skillValue}
                key={skill.id}
              >
                <span>
                  <span className="label">{skill?.skillName}</span>
                  <span className="number">{skill?.skillValue}%</span>
                </span>
                <div className="background">
                  <div className="bar">
                    <div
                      className="bar_in"
                      style={{ width: skill?.skillValue + "%" }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default Skills;
